import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from 'src/@/components/ui/button';
import {
    Sheet,
    SheetContent,
    SheetTitle,
} from 'src/@/components/ui/sheet';
import { useSelector, useDispatch } from 'react-redux';
import ChatWindow from './ChatWindow';
import {
    setChatInfo,
    setLimparChatInfo,
    setMessagesWhatsapp,
    setMessagesArquivosWhatsapp,
} from 'src/redux/slices/chat';

// ----------------------------------------------------------------------

DrawerChatWhatsapp.propTypes = {
    onClose: PropTypes.func,
    chat: PropTypes.object,
    open: PropTypes.bool,
    source: PropTypes.string,
};

export default function DrawerChatWhatsapp({ chat, open, onClose, source }) {
    const dispatch = useDispatch();
    const messagesEnd = useRef(null);
    const { t } = useTranslation('chat');
    const { chatInfo } = useSelector((state) => state.chat);
    const { config } = useSelector((state) => state.global);
    const [tagsChamado, setTagsChamados] = useState(chat?.tags_ids);
    const [sidebarLeft, setSidebarLeft] = useState(false);

    function handleClose() {
        onClose();
        dispatch(setChatInfo(null));
        dispatch(setLimparChatInfo());
        dispatch(setMessagesWhatsapp([]));
        dispatch(setMessagesArquivosWhatsapp([]));
    }

    useEffect(() => {
        scrollToBottom();
    }, [chat, open, tagsChamado]);

    const scrollToBottom = () => {
        if (messagesEnd.current) {
            messagesEnd.current.scrollTop = messagesEnd.current.scrollHeight;
        }
    };

    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && handleClose()}>
            <SheetContent
                side="bottom"
                hideCloseButton
                className="h-screen w-screen max-w-none p-0 border-none"
            >
                <SheetTitle className="sr-only">Chat WhatsApp</SheetTitle>

                {/* Header Container */}
                <div className="bg-white shadow-md h-12 min-h-[48px] w-full">
                    <div className="min-h-[48px] h-12 px-4 flex items-center gap-2">
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={handleClose}
                            aria-label={t('common:buttons.close')}
                            className="h-9 w-9 text-gray-900 hover:bg-gray-100"
                        >
                            <ArrowLeft className="h-[18px] w-[18px]" />
                        </Button>
                        <p className="text-gray-900 text-sm font-medium">{t('common:buttons.back')}</p>
                    </div>
                </div>

                {/* Main Content Area */}
                <div className="overflow-hidden h-[calc(100vh-48px)] bg-white">
                    {chatInfo && (
                        <ChatWindow
                            sidebarLeft={sidebarLeft}
                            changeOpenSidebarLeft={() => setSidebarLeft(!sidebarLeft)}
                            config={config}
                            chatInfo={chatInfo}
                            source={source}
                            onCloseModal={handleClose}
                        />
                    )}
                </div>
            </SheetContent>
        </Sheet>
    );
}
